module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Bu1N1g/tc-custom/9781488050329.jpg?1701951200875",
      "alt": "This image is the cover for the book Holiday Secret"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Holiday Secret\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A princess goes undercover as a nanny and falls for her handsome employer in this romantic suspense from a "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestseller.")]), _c('br'), _c('br'), _vm._v("Princess Katherine Wyndham has gone from privileged royalty to secret agent. Her mission: to locate her brother—the long-lost crown prince. Her cover: nanny for handsome tycoon Trey Sutherland."), _c('br'), _c('br'), _vm._v("Caring for Trey’s kids comes more naturally to Katherine than any royal duty ever has. And falling for the brooding widower is equally effortless. But Katherine has always been the plain-Jane princess. Is it too much to hope that Trey could want a happily-ever-after with her . . . especially once he discovers who she really is?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Suzanne Brockmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Suzanne Brockmann is an award-winning author of more than fifty books and is widely recognized as one of the leading voices in romantic suspense. Her work has earned her repeated appearances on the New York Times bestseller list, as well as numerous awards, including Romance Writers of America’s #1 Favorite Book of the Year and two RITA awards. Suzanne divides her time between Siesta Key and Boston. Visit her at www.SuzanneBrockmann.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0